import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum InvoiceCycleDraftFields {
    TITLE_TEMPLATE = 'titleTemplate',
    INTERVAL = 'interval',
    RECURRING_ITEMS = 'recurringItems',
    ONE_TIME_ITEMS = 'oneTimeItems',
    STUDENT = 'student',
    INVOICE_CYCLE = 'invoiceCycle',
    SCHEDULED_PRODUCT_SERIES_ITEMS = 'scheduledProductSeriesItems',
    CREATED_AT = 'createdAt',
    UPDATED_AT = 'updatedAt',
}

export namespace InvoiceCycleDraftFields {
    type Data = {
        text: string;
        readonly?: boolean;
    }

    export const Record: Record<InvoiceCycleDraftFields, Data> = {
        [InvoiceCycleDraftFields.TITLE_TEMPLATE]: {
            text: 'Titel Vorlage',
            readonly: false,
        },
        [InvoiceCycleDraftFields.INTERVAL]: {
            text: 'Intervall',
            readonly: false,
        },
        [InvoiceCycleDraftFields.RECURRING_ITEMS]: {
            text: 'Wiederkehrende Artikel',
            readonly: false,
        },
        [InvoiceCycleDraftFields.ONE_TIME_ITEMS]: {
            text: 'Einmalige Artikel',
            readonly: false,
        },
        [InvoiceCycleDraftFields.STUDENT]: {
            text: 'Schüler',
            readonly: true,
        },
        [InvoiceCycleDraftFields.INVOICE_CYCLE]: {
            text: 'Erzeugter Rechnungslauf',
            readonly: true,
        },
        [InvoiceCycleDraftFields.SCHEDULED_PRODUCT_SERIES_ITEMS]: {
            text: 'Serienversand-Konfiguration',
            readonly: true,
        },
        [InvoiceCycleDraftFields.CREATED_AT]: {
            text: 'Erzeugungsdatum',
            readonly: true,
        },
        [InvoiceCycleDraftFields.UPDATED_AT]: {
            text: 'Aktualisierungsdatum',
            readonly: true,
        },
    };

    export const Items = mapRecordToItems(Record);
}
